import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance/axiosInstance";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { EndSeriesRequest } from "../contracts/EndSeriesRequest";
import { SessionResponse } from "../contracts/SessionResponse";
import { Session } from "../models/Session";
import { SessionResponseMapper } from "../mappers/SessionResponseMapper";

const responseMapper = new SessionResponseMapper();

/** End a recurring session's series on a date; history and billed visits stay. */
export const endSeries = createAsyncThunk<
  Session,
  { sessionId: string; request: EndSeriesRequest },
  { rejectValue: ApiErrorResponse }
>("sessions/endSeries", async ({ sessionId, request }, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post<SessionResponse>(
      `/bookings/${sessionId}/end-series`,
      request
    );
    return responseMapper.toSession(response.data);
  } catch (error: unknown) {
    return rejectWithValue(toApiError(error, "Failed to end the series"));
  }
});

/** Hard-cancel a session created by mistake; blocked while attendance is marked. */
export const cancelSession = createAsyncThunk<
  Session,
  string,
  { rejectValue: ApiErrorResponse }
>("sessions/cancelSession", async (sessionId, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post<SessionResponse>(
      `/bookings/${sessionId}/cancel`
    );
    return responseMapper.toSession(response.data);
  } catch (error: unknown) {
    return rejectWithValue(toApiError(error, "Failed to cancel the session"));
  }
});
